/**
 * @module components/theme/Unauthorized/Unauthorized
 */

import React from 'react';

import { Unauthorized as UnauthorizedItalia } from 'design-comuni-plone-theme/components/ItaliaTheme';

/**
 * unauthorized function.
 * @function Unauthorized
 * @returns {string} Markup of the unauthorized page.
 */
const Unauthorized = () => {
  return <UnauthorizedItalia />;
};

export default Unauthorized;
